export const DEFAULT_MALL_DATA = {
  dataProviderMallSeq: 0,
  stipulationExposureYn: '',
  interlockOpenYn: '',
  mallType: '0',
  fileSeq: 0,
  filePath: null,
  fileUrl: null,
  mallSeq: 0,
  mallName: '',
  secondAuthReleaseType: null,
  secondAuthReleaseMessage: null,
  mallScrapingTypeCd: '',
  secondAuthUseYn: '',
  secondAuthExposureType: null,
  secondAuthMethodSmsYn: null,
  secondAuthMethodEmailYn: null,
  itemList: [],
};

// 구조 - list: [DEFAULT_MALL_DATA]
export const DEFAULT_MALL_LIST_DATA = {
  corporateClosedShoppingMallList: [],
  generalMallList: [],
  homeShoppingMallList: [],
  notOpenMallList: [],
  openMarketList: [],
  paymentGateWqyMallList: [],
  specialtyMallList: [],
};

export const DEFAULT_STIPULATION_LIST = [
  {
    dataProviderMallStipulationMappingSeq: 0,
    essentialYn: '',
    stipulationBeginDate: '',
    stipulationCd: '',
    stipulationCdName: '',
    stipulationContents: '',
    stipulationTypeCd: 'STC100',
  },
];

export const INIT_FORM_DATA = {
  dataProviderSeq: 0,
  mallScrapingTypeCd: '',
  mallAccountTypeCd: '',
  mallId: '',
  mallPassword: '',
  secondAuthReleaseYn: '',
  businessManagerName: '',
  businessManagerMobilePhone: '',
  extraAuthFactor: '',
  secondAuthUseYn: '',
  secondAuthType: '',
  secondAuthValue: '',
  businessDataProviderMallMappingSeq: 0,
  qrFileSeq: 0,
  qrFileUrl: '',
};

export const INIT_SELECTED_MANAGER_DATA = {
  interlockBusinessManagerName: '',
  interlockBusinessManagerMobilePhoneNumber: '',
};
